import axios from 'axios';
import BaseUrl from '../Util/BaseUrl';

const API_URL = BaseUrl.baseUrl+"api/subcategories";

const getSubcategoriesByCategory = async () => {
    try {
        const response = await axios.get(`${API_URL}/byCategoryAll/1`);
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data : 'Failed to get Subcategory');       
    }
};

const SubcategoryService = {
    getSubcategoriesByCategory
};

export default SubcategoryService;